import React, { useEffect } from "react";
import { useStore } from "../../../hooks";
import { useSearchParams, useNavigate } from "react-router-dom";
import DynamicNotes from "../../../elements/v2/DynamicNotes/DynamicNotes";
import { NOTE_CATEGORIES_LIST } from "../../../utils/enums";
import { observer } from "mobx-react";
import Alerts from "../../../elements/v2/Alerts/Alerts";
import { useUserCheckPermissions } from "../../../hooks/useUserCheckPermissions";
import { PermissionCodes } from "../../../utils/enums";

const BaseUnifiedProfile = observer(({ children }) => {
  // [DEPRECATED_GRAPHQL] - alertStore comentado porque usa GraphQL queries
  // const { authStore, unifiedCustomerProfileStore, assistanceUCPStore, changeTitle, alertStore, notesStore, contactStore } = useStore();
  const { authStore, unifiedCustomerProfileStore, assistanceUCPStore, changeTitle, notesStore, contactStore } = useStore();
  const { selectedAccount } = authStore;
  const [searchParams,] = useSearchParams();
  notesStore.setCategories(NOTE_CATEGORIES_LIST);
  const selectedAccountId = selectedAccount?.id;
  const [showAlert, setShowAlert] = React.useState(false);
  const { checkPermission } = useUserCheckPermissions();
  useEffect(() => {
    const segmentId = searchParams.get("id");
    if (selectedAccountId && segmentId) {
      assistanceUCPStore.resetTimelineState();
      assistanceUCPStore.fetchCustomerMessages(selectedAccountId, segmentId);
    }
  }, [assistanceUCPStore, selectedAccountId, searchParams]);

  // [DEPRECATED_GRAPHQL] - alertStore comentado porque usa GraphQL queries
  // useEffect(() => {
  //   if (selectedAccount) {
  //     alertStore.setAccountId(selectedAccount.id);
  //   }

  //   if (authStore.userId) {
  //     alertStore.setUserId(authStore.userId);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [selectedAccount, authStore.userId]);

  const navigate = useNavigate();
  changeTitle(null);

  useEffect(() => {
    unifiedCustomerProfileStore.onClearUCP();
    const segmentId = searchParams.get("id");
    // [DEPRECATED_GRAPHQL] - alertStore comentado porque usa GraphQL queries
    // alertStore.setSegmentId(segmentId);

    if (!segmentId) {
      navigate("/contacts");
      return;
    }

    // [DEPRECATED_GRAPHQL] - Para eliminación: contactStore.getSingleContact y unifiedCustomerProfileStore.fetchUCPData usan GraphQL queries
    // TODO: Eliminar después de verificar que nuevas APIs funcionan correctamente
    
    // const validateContact = async () => {
    //   try {
    //     const response = await contactStore.getSingleContact(selectedAccount.id, segmentId);
    //     if (!response?.data?.getSingleContact) {
    //       setShowAlert(true);
    //     }
    //   } catch (error) {
    //     setShowAlert(true);
    //   }
    // };

    // validateContact();

    // // Fetch contact info
    // unifiedCustomerProfileStore.fetchUCPData(
    //   selectedAccount.id,
    //   segmentId,
    //   "card_contact_info",
    //   authStore.userId,
    //   authStore.isGroupSuperAdmin,
    // );

    // // Fetch garage info
    // unifiedCustomerProfileStore.fetchUCPData(
    //   selectedAccount.id,
    //   segmentId,
    //   "card_garage",
    //   authStore.userId,
    //   authStore.isGroupSuperAdmin,
    // );

    // // Fetch appointments info
    // unifiedCustomerProfileStore.fetchUCPData(
    //   selectedAccount.id,
    //   segmentId,
    //   "card_appointments",
    //   authStore.userId,
    //   authStore.isGroupSuperAdmin,
    // );

    // // Fetch team
    // unifiedCustomerProfileStore.fetchUCPData(
    //   selectedAccount.id,
    //   segmentId,
    //   "card_team",
    //   authStore.userId,
    //   authStore.isGroupSuperAdmin,
    // );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unifiedCustomerProfileStore]);

  useEffect(() => {
    const segmentId = searchParams.get("id");
    if(unifiedCustomerProfileStore.selectedCar){

      // Fetch opportunities info
      unifiedCustomerProfileStore.fetchUCPData(
        selectedAccount.id,
        segmentId,
        "card_opportunity",
        authStore.userId,
        authStore.isGroupSuperAdmin,
      );

      // Fetch orders info
      unifiedCustomerProfileStore.fetchUCPData(
        selectedAccount.id,
        segmentId,
        "card_orders",
        authStore.userId,
        authStore.isGroupSuperAdmin,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unifiedCustomerProfileStore.garageInfo, unifiedCustomerProfileStore.selectedCar]);

  // [DEPRECATED_GRAPHQL] - alertStore comentado porque usa GraphQL queries
  // useEffect(() => {
  //   alertStore.onClearUCP();
  //   alertStore.fetchNotificationsUCP(alertStore.accountId, alertStore.userId, null);
  // }, [alertStore]);

  return (
    <>
      {showAlert && (
        <Alerts
          title="Error"
          message="Customer profile not found. This contact may have been deleted."
          severity="error"
          onClose={() => setShowAlert(false)}
        />
      )}
      
      {/* [DEPRECATED_GRAPHQL] - alertStore comentado porque usa GraphQL queries */}
      {/* {checkPermission(PermissionCodes.UCP_NOTES, "CREATE") && (
        <DynamicNotes noted={alertStore.segmentId}/>
      )} */}
      {children}
    </>
  );
});

export default BaseUnifiedProfile;
